import { gql } from "@apollo/client";
import { AccountDeliveryDriverType } from "../../types/AccountDeliveryDriverType";
import { AccountDeliveryDriverInput } from "../../types/AccountDeliveryDriverInput";
import { client } from "graphql/client";

export const CREATE_ACCOUNT_DELIVERY_DRIVER_FOR_PORTAL = gql`
    mutation CreateAccountDeliveryDriverForPortal($input: AccountDeliveryDriverInput!) {
        createAccountDeliveryDriverForPortal(input: $input) {
            id
        }
    }
`;

// 总部入口：返回字段别名为 createAccountDeliveryDriverForPortal，与 DSP 入口共用响应类型
export const CREATE_ACCOUNT_DELIVERY_DRIVER_FOR_CENTRAL = gql`
    mutation CreateAccountDeliveryDriverForCentral($input: AccountDeliveryDriverInput!) {
        createAccountDeliveryDriverForPortal: createAccountDeliveryDriverForCentral(input: $input) {
            id
        }
    }
`;

// 仓库入口：需传当前仓库ID，后端校验仓库权限及目标 DSP 是否关联该仓库
export const CREATE_ACCOUNT_DELIVERY_DRIVER_FOR_WMS = gql`
    mutation CreateAccountDeliveryDriverForWms($input: AccountDeliveryDriverInput!, $warehouseId: Long!) {
        createAccountDeliveryDriverForPortal: createAccountDeliveryDriverForWms(input: $input, warehouseId: $warehouseId) {
            id
        }
    }
`;

export interface CreateAccountDeliveryDriverForPortalResponse {
    createAccountDeliveryDriverForPortal: AccountDeliveryDriverType;
}

export interface CreateAccountDeliveryDriverForPortalVariables {
    input: AccountDeliveryDriverInput;
    warehouseId?: number;
}

export const createAccountDeliveryDriverForPortal = async (input: AccountDeliveryDriverInput): Promise<boolean> => {
    const { data } = await client.mutate({
        mutation: CREATE_ACCOUNT_DELIVERY_DRIVER_FOR_PORTAL,
        variables: { input }
    });
    return data.createAccountDeliveryDriverForPortal;
};
